export const setDisableDatagridState = (state, action): any => {
  const updatedState = {
    ...state,
    status: action.payload.status,
  };

  return updatedState;
};
